<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button *ngIf="isError" type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{{message}}</h4>
            </div>
            <div class="modal-body">
                <!--<div class="row">-->
                    <!--<img src="{{entertainment}}">-->
                    <h5 *ngIf="isError">Please cut and paste the text below and provide to Engineering</h5>
                    <h5>{{detail}}</h5>
                <!--</div>-->
            </div>
        </div>
    </div>
</div>
